export default __webpack_public_path__ + "static/media/icon-phone-design1.ae3592d9.svg";